import {DEFAULT_LINE_PLOT_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {LinePlotDisplayFnArgs} from '../types';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';

export const getYAxisMinDisplayRow = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
}: LinePlotDisplayFnArgs) => {
  const currTemplateYAxisMin = currTemplateLinePlotSettings?.yAxisMin;
  const newTemplateYAxisMin = currWorkspaceLinePlotSettings?.yAxisMin;

  return {
    groupTitle: 'Y axis',
    label: 'Min',
    field: 'yAxisMin' as keyof LinePlotTemplateSettings,
    currValue: currTemplateYAxisMin,
    currDisplayValue:
      currTemplateYAxisMin == null
        ? undefined
        : currTemplateYAxisMin.toString(),
    newValue: newTemplateYAxisMin ?? DEFAULT_LINE_PLOT_SETTINGS.yAxisMin,
    newDisplayValue:
      newTemplateYAxisMin == null ? undefined : newTemplateYAxisMin.toString(),
  };
};
